import type { DriveStep } from 'driver.js';

const at = (id: string) => `[data-tour="${id}"]`;

/** "Tour this page" for Billing (/billing). Anchors live in BillingPage.tsx. */
export function getBillingTourSteps(): DriveStep[] {
  return [
    {
      popover: {
        title: 'Billing',
        description:
          'Change your plan, add extras like AI Marketer or SEO Autopilot, and find your invoices. ' +
          'Payments are handled securely by Stripe.',
      },
    },
    {
      element: at('billing-current'),
      popover: {
        title: 'Your current plan',
        description:
          'Your plan, when it renews, and the card on file. To downgrade, use “Cancel subscription” ' +
          '— your plan stays active until the end of the billing period, then moves to Free.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: at('billing-plans'),
      popover: {
        title: 'All plans',
        description:
          'Compare what each plan includes and click Upgrade on the one you want. Your current plan ' +
          'is marked.',
        side: 'top',
        align: 'center',
      },
    },
    {
      element: at('billing-interval'),
      popover: {
        title: 'Monthly or annual',
        description: 'Switch between monthly and annual prices. Paying annually waives the setup fee.',
        side: 'bottom',
        align: 'end',
      },
    },
    {
      element: at('billing-addons'),
      popover: {
        title: 'Add-ons',
        description:
          'Add AI Marketer or SEO Autopilot. They are included on Brokerage Growth and can be added ' +
          'on Agent IDX Growth. Remove one and the unused part comes back as a credit on your next ' +
          'invoice.',
        side: 'top',
        align: 'start',
      },
    },
    {
      element: at('billing-invoices'),
      popover: {
        title: 'Invoices',
        description: 'Open any monthly invoice to view or print it.',
        side: 'top',
        align: 'start',
      },
    },
  ];
}
